import React, { FC } from 'react';
import classNames from 'classnames';

import { Amount } from 'app/design-system/components/Amount';
import { Trans, useTranslation } from 'app/lang';
import { replacingHyphenOnDash } from 'app/lib/replaceDashSymbol';

import { PledgeStakeChainDAO } from '../../../../../types/backend/paymentOptions';

import dictionary from './ChainEntry.dictionary.json';

import entryStyles from '../../../../EntryComponents/EntryComponents.module.scss';
import styles from './ChainEntry.module.scss';

// ---

type ChainEntryProps = {
  data: PledgeStakeChainDAO;
  isSelected: boolean;
  isDisabled: boolean;
};

const MAX_NUMBER_OF_VISIBLE_BETS = 3;

const ChainEntry: FC<ChainEntryProps> = ({ data, isSelected, isDisabled }) => {
  const { t } = useTranslation();
  const matchesLength = data.chainMatches.length;

  const _className = classNames(styles.chainEntry, {
    [styles.selectedEntry]: isSelected || isDisabled,
  });

  return (
    <div className={_className}
         title={isDisabled ? t(dictionary.title) : ''}
         data-test="chainEntry-container">
      <p className={styles.entryName}
         data-test="chainEntry-entryName">
        <span className={styles.name}
              data-test="chainEntry-name">
          {t(dictionary.chinEntryName, { matchesLength })}
        </span>
        {isSelected && (
          <span className={styles.selected}
                data-test="chainEntry-selected">
            {t(dictionary.selectedText)}
          </span>
        )}
      </p>
      <div className={styles.matches}
           data-test="chainEntry-matches">
        {data.chainMatches.slice(0, MAX_NUMBER_OF_VISIBLE_BETS).map((matchName, index) => (
          <p key={index}
             data-test="chainEntry-matchName"
             className={styles.matchName}>
            {replacingHyphenOnDash(matchName)}
          </p>
        ))}
        {matchesLength > MAX_NUMBER_OF_VISIBLE_BETS && (
          <span className={styles.maxNumberOfVisibleText}
                data-test="chainEntry-remainingBets">
            {t(dictionary.bet, { count: matchesLength - MAX_NUMBER_OF_VISIBLE_BETS })}
          </span>
        )}
      </div>
      <div className={classNames(entryStyles.datetime, styles.maxWinning)}
           data-test="chainEntry-maxWinning">
        <Trans data={dictionary.maxWinningText}
               components={{
                 amount: (
                   <Amount value={data.maxWinning}
                           className={styles.amount}
                           currency={data.currency} />
                 ),
               }} />
      </div>
    </div>
  );
};

export default ChainEntry;
